
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"13","height":"8","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"opacity":".5","fill-rule":"evenodd","clip-rule":"evenodd","d":"M.272.293a.882.882 0 011.313 0L6.5 5.586 11.415.293a.882.882 0 011.313 0c.363.39.363 1.024 0 1.414l-5.571 6a.882.882 0 01-1.314 0l-5.571-6a1.055 1.055 0 010-1.414z"}})])
          )
        }
      }
    